import { LanguageOption } from "./language";

export interface MotesUrlParams {
    project: string,
    mote: string,
    poolKey: string,
    previewKey: string,
    language?: LanguageOption,
    disableIntroFlow?: boolean,
}
